import { LabelInfo } from './get-recomendations'
import splitIntoColumns from './split-into-columns'

export function distributeToStreams(labelInfo: LabelInfo, targetCols: number) {
    // Ищем лучший вариант количества ручьев
    // const cols = findTargetOrSmallerCols([targetCols], targetCols)
    // Делим по ровну на лучшее количество ручьев
    const copiesByStreems = splitIntoColumns(labelInfo, targetCols)

    return copiesByStreems
}
